module.exports = __webpack_public_path__ + "static/media/ceilings_gwp_10y_y.914c099b.csv";